module.exports = __webpack_public_path__ + "static/img/中建七局_logo.d2ee44f9.png";